import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { LabelSettings } from '../utils/receiptTypes'
import { DEFAULT_LABEL_SETTINGS } from '../utils/receiptTypes'

export function useLabelSettings(restaurantId: number) {
  return useQuery({
    queryKey: ['label-settings', restaurantId],
    queryFn: async () => {
      const response = await apiClient.get<LabelSettings>(
        '/labelSettings',
        { params: { restaurantId } },
      )
      return response.data
    },
    enabled: !!restaurantId,
    // Label settings rarely change — cache for a long time
    staleTime: 5 * 60 * 1000, // 5 minutes
    placeholderData: DEFAULT_LABEL_SETTINGS,
  })
}
